import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import { bindDocumentLanguage } from './documentLanguage';
import { PSEUDO_LOCALE, pseudoResources } from './pseudoLocale';

// Define supported languages
export const supportedLanguages = {
  en: { name: 'English', nativeName: 'English' },
} as const;

export type SupportedLanguage = keyof typeof supportedLanguages;

// Resources for i18next
const resources: Record<string, { translation: Record<string, unknown> }> = {
  en: { translation: en },
};

// REV-795: the en-XA pseudo-locale, for development and tests only. It is not
// in supportedLanguages, so no one can pick it, and the API would refuse to
// store it. Switch to it with localStorage.setItem('i18nextLng', 'en-XA').
if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
  resources[PSEUDO_LOCALE] = { translation: pseudoResources(en) };
}

void i18n
  // Detect user language from browser
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      // React already escapes values
      escapeValue: false,
    },

    // Debug mode in development (but not during tests)
    debug: import.meta.env.DEV && import.meta.env.MODE !== 'test',
  });

// REV-796: <html lang>/<html dir> follow the active language, from first paint.
bindDocumentLanguage(i18n);

export default i18n;
